import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { allProducts, productCategories } from '../../mocks/products';

export default function ProductCategoryPage() {
  const { categorySlug } = useParams();
  
  const category = productCategories.find(c => c.slug === categorySlug);
  const categoryProducts = allProducts.filter(p => p.category === category?.id);

  if (!category) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Navbar />
        <div className="pt-32 pb-20 text-center">
          <h1 className="text-3xl font-bold text-navy-900 mb-4">Category Not Found</h1>
          <Link to="/shop" className="text-primary-600 hover:text-primary-700 cursor-pointer">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Header */}
      <section className="pt-32 pb-12 bg-gradient-to-br from-navy-900 to-navy-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-3 mb-4">
            <Link to="/shop" className="text-gray-300 hover:text-white cursor-pointer">
              Shop
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-white">{category.name}</span>
          </div>
          <div className="flex items-center space-x-6 mb-6">
            <div className={`w-20 h-20 flex items-center justify-center bg-gradient-to-br ${category.color} rounded-2xl`}>
              <i className={`${category.icon} text-4xl text-white`}></i>
            </div>
            <div>
              <h1 className="text-5xl font-bold text-white mb-2">
                {category.name}
              </h1>
              <p className="text-xl text-gray-300">
                {category.description}
              </p>
            </div>
          </div>
          <p className="text-gray-400">
            {categoryProducts.length} products available
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-product-shop>
            {categoryProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300"
              >
                <div className="aspect-square bg-gray-50 p-6">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-contain"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-navy-900 mb-2">
                    {product.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3">
                    {product.specification}
                  </p>
                  <div className="mb-4">
                    <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full">
                      {product.purity} Pure
                    </span>
                  </div>
                  <div className="space-y-2">
                    <Link
                      to={`/product/${product.slug}`}
                      className="block w-full px-4 py-2.5 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors text-center cursor-pointer whitespace-nowrap"
                    >
                      Request Quote
                    </Link>
                    <Link
                      to={`/product/${product.slug}`}
                      className="block w-full px-4 py-2.5 border border-gray-300 text-navy-900 text-sm font-semibold rounded-lg hover:bg-gray-50 transition-colors text-center cursor-pointer whitespace-nowrap"
                    >
                      View Details
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}